import Vue from 'vue'
import axios from 'axios'
import VueCalendar from 'v-calendar'
import moment from 'moment'
import 'moment/locale/ru'

const MOMENT_DATE_FORMAT = 'YYYY-MM-DD';
(function ($) {
  'use strict'
  $(function () {



    //Модалка овердрафта, когда не хватает депозита
    $(document).on('click','[data-action="doOrderProceed"]',(event)=>{
      let $depositAttentionModal = $('#depositCantCheckout');
      if ($depositAttentionModal.length){
        event.preventDefault();
        event.stopPropagation();
        $depositAttentionModal.foundation();
        $depositAttentionModal.foundation('open');
      }
    });


    $(document).on('change', '[data-action="profileDepositDateChanged"]', () => {
      $.ajax({
        url: window.location.href,
        method: 'get',
        dataType: 'html',
        data: {
          dateFrom: $('[name="dateFrom"]').val(),
          dateTo: $('[name="dateTo"]').val(),
        },
        cache: false,
        success: function (data) {
          $('#order-tabs-prepay').html($(data))
        },
        error: function (data) {
          console.warn(data)
        }
      })

    })

    if ($('#prepayDepositDatePicker').length) {
      const daysOfWeek = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс']
      Vue.use(VueCalendar)
      window.prepayDepositDatePicker = new Vue({
        el: '#prepayDepositDatePicker',
        components: { VueCalendar },
        data: {
          disabled:false,
          attrs: [
          ],
          range: {
            start: new Date(window.prepayDeposit.dateStartValue),
            end: new Date(window.prepayDeposit.dateEndValue)
          },
          modelConfig: {
            start: {
              timeAdjust: '00:00:00',
            },
            end: {
              timeAdjust: '23:59:59',
            },
          },
          dateStart: window.prepayDeposit.dateStart,
          dateEnd: window.prepayDeposit.dateEnd,
        },
        methods: {
          changeCalendarDate (one, two) {
          },
          vCalGetDayName (date) {
            return daysOfWeek[date.weekday]
          },
          change: function () {
            this.disabled = true;
            let start = moment(this.range.start);
            let end = moment(this.range.end);
            return axios.request(
              {
                url: window.location.href,
                method: 'get',
                params: {
                  dateFrom: start.format(MOMENT_DATE_FORMAT),
                  dateTo: end.format(MOMENT_DATE_FORMAT),
                },
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
              }
            ).then((result)=>{
              this.disabled = false;
              $('#order-tabs-prepay').html($(result.data));
              $('[data-entity="prepay-date-start"]').html(start.format('DD.MM.YYYY'))
              $('[data-entity="prepay-date-end"]').html(end.format('DD.MM.YYYY'))
              $('#prepayDepositDatePickerReveal').foundation('close');

            }).catch(()=>{
              this.disabled = false;
            })
          },
        },
      })
    }

  })

})(jQuery)



